import React, { act, use, useEffect, useState } from "react";
import { useAuth } from "../../../auth/FirebaseAuth.js";

import {
  countCollection,
  createDoc,
  deleteDocById,
  getFlutterTime,
  getFlutterTimeFromSeconds,
  getLocalStringFromFlutter,
  getRefFromId,
  queryCollection,
} from "../../../models/DataFunctions.js";
import SecondaryButton from "../../../buttons/SecondaryButton.js";

import { useAppContext } from "../../../config/AppContext.js";

import { useSnackbar } from "notistack";

import TextField2T from "../../../textfields/TextField2T.js";
import PrimaryButton from "../../../buttons/PrimaryButton.js";

import SmallSpinner from "../../../loading/SmallSpinner.js";
import NavBarButton from "../../../buttons/NavBarButton.js";
import { BlockNumer } from "../../home/MasterSmallStats.js";
import Icon1 from "../../../icons/Icon.js";
import TextFieldEmail from "../../../textfields/TextFieldEmail.js";
import DataGridGPT2 from "../../../tables/DataGridGPT2.js";
import { dbHexamails } from "../../../config/FirebaseConfig.js";
import { getDoc, updateDoc } from "firebase/firestore";
import Modal1 from "../../../modals/Modal1.js";
import { email_base } from "./hexamails_data.js";
import TabGPT from "../../../tabs/TabGPT.js";
import { HM_NavBar } from "./HM_NavBar.js";
import { CampaignPage } from "./CampaignPage.js";
import { EmailTemplatePage } from "./EmailTemplatePage.js";
import { transformEmailDeliveredToTable } from "../../../models/OrgFunctions.js";

function EmailKPIS({ navigateWorkspace }) {
  const { currentUser, loading } = useAuth();

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [userData, setUserData] = useState(null);
  const [tab, setTab] = useState("kpis");
  const [email_selected, setEmailSelected] = useState(null);
  const [campaign_selected, setCampaignSelected] = useState(null);
  const [active_campaign_selected, setActiveCampaignSelected] = useState(null);
  const [choose_email_for_campaign, setChooseEmailForCampaigns] =
    useState(false);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [email_templates, setEmailTempaltes] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [active_campaigns, setActiveCampaigns] = useState([]);
  const [choose_user_open, setChooseUserOpen] = useState(false);
  const [masters, setMasters] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const [tab_campaign, setTabCampaign] = useState("campaign");
  const [emails_delivered, setEmailsDelivered] = useState([]);
  const [history_tab, setHistoryTab] = useState("campaign");
  const [history_searchvalue, setHistorySearchValue] = useState("");

  const handleFetchData = async () => {
    let emails_delivered_count = await countCollection(
      "email_delivered",
      [],

      dbHexamails
    );
    let emails_clicked_count = await countCollection(
      "email_delivered",
      [
        {
          field: "state",
          operator: "==",
          value: "clicked",
        },
      ],

      dbHexamails
    );
    let ctr = (emails_clicked_count / (emails_delivered_count || 1)) * 100;

    setKPIsDict({
      emails_sent: emails_delivered_count,
      emails_clicked: emails_clicked_count,
      ctr: ctr.toFixed(2),
    });
  };
  const [kpis_dict, setKPIsDict] = useState({
    emails_sent: 0,
    emails_clicked: 0,
    ctr: 0,
  });
  const [email_delivered_open, setEmailDeliveredOpen] = useState(false);

  useEffect(() => {
    handleFetchData();
  }, []);
  // If the data is still loading or the user is not authenticated, show a loading message
  if (loading || !currentUser) {
    return <SmallSpinner></SmallSpinner>;
  }

  // Render the client data
  return (
    <div className="flex flex-row gap-2 mt-4">
      <BlockNumer
        title="Emails envoyés"
        icon="email"
        number={kpis_dict.emails_sent}
      />
      <BlockNumer
        title="Emails cliqués"
        icon="open"
        number={kpis_dict.emails_clicked}
      />
      <BlockNumer title="CTR" sufix="%" icon="stats" number={kpis_dict.ctr} />
    </div>
  );
}

export default EmailKPIS;
